import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension'
import { userLoginReducer, userRegisterReducer, userDetailsReducer, userUpdateProfileReducer } from './reducers/userReducers';

import { vacationListReducer, vacationCreateReducer, vacationDeleteReducer, vacationUpdateReducer, vacationPoolReducer } from './reducers/vacationReducers';
import { employmentListReducer, employmentCreateReducer, employmentDeleteReducer, employmentUpdateReducer } from './reducers/employmentReducer';
import { educationListReducer, educationCreateReducer, educationDeleteReducer, educationUpdateReducer } from './reducers/educationReducer';
import { languageListReducer, languageCreateReducer, languageDeleteReducer, languageUpdateReducer } from './reducers/languageReducer';
import { additionalSectionsListReducer, additionalSectionsUpdateReducer} from './reducers/additionalSectionsReducers';
import { salaryListReducer } from './reducers/salaryReducer';

import {
    questionnaireCurrentReducer,
    questionnaireSaveAnswerReducer,
    questionnaireCompleteReducer,
    questionnaireCheckAccessReducer,
} from './reducers/questionnaireReducers';

export const reducer = combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,

    vacationList: vacationListReducer,
    vacationCreate: vacationCreateReducer,
    vacationDelete: vacationDeleteReducer,
    vacationUpdate: vacationUpdateReducer,
    vacationPool: vacationPoolReducer,

    employmentList: employmentListReducer,
    employmentCreate: employmentCreateReducer,
    employmentDelete: employmentDeleteReducer,
    employmentUpdate: employmentUpdateReducer,

    educationList: educationListReducer,
    educationCreate: educationCreateReducer,
    educationDelete: educationDeleteReducer,
    educationUpdate: educationUpdateReducer,

    languageList: languageListReducer,
    languageCreate: languageCreateReducer,
    languageDelete: languageDeleteReducer,
    languageUpdate: languageUpdateReducer,

    additionalSectionsList: additionalSectionsListReducer,
    additionalSectionsUpdate: additionalSectionsUpdateReducer,

    questionnaireCurrent: questionnaireCurrentReducer,
    questionnaireSaveAnswer: questionnaireSaveAnswerReducer,
    questionnaireComplete: questionnaireCompleteReducer,
    questionnaireCheckAccess: questionnaireCheckAccessReducer,

    salaryList: salaryListReducer,
})


const userInfoFromStorage = localStorage.getItem('userInfo') ?
    JSON.parse(localStorage.getItem('userInfo')) : null

const initialState = {
    userLogin: { userInfo: userInfoFromStorage }
}

const middleware = [thunk]

// const store = createStore(reducer, initialState,
//     composeWithDevTools(applyMiddleware(...middleware)))


// export default store  +
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; 
// To w zasadzie robi to, co miał robić niekompatybilny pakiet, ale bez tego pakietu.

const store = createStore(reducer, initialState,
    composeEnhancers(applyMiddleware(...middleware)))


export default store